exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-img-top[data-v-479b3535] {\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n.card[data-v-479b3535] {\n    transition: transform 0.5s;\n    transform: scale(1);\n}\n.card-hover[data-v-479b3535]:hover {\n    transition: transform 0.5s;\n    transform: scale(1.04);\n    z-index: 999;\n}\n.card.card-img-holder .card-img-absolute[data-v-479b3535] {\n    right: -4px;\n}\n", ""]);

// exports
